import { AppViewport } from './components/app/AppViewport';
import { InstallPrompt } from './components/system/InstallPrompt';
import { ResetDemoControl } from './components/system/ResetDemoControl';
import { TurnstileRuntime } from './features/auth/TurnstileRuntime';
import { useLegacyRuntime } from './legacy/useLegacyRuntime';
import { useNativeRuntime } from './native/useNativeRuntime';

/** React owns the stable shell while current-main features are extracted behind it. */
export function App() {
  const isNative = useNativeRuntime();
  useLegacyRuntime();

  return (
    <>
      <TurnstileRuntime />
      <AppViewport />
      {!isNative && <InstallPrompt />}
      {!isNative && <ResetDemoControl />}
    </>
  );
}
